var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sms_svg__a)",
    d: "M26.578 11.929c0 6.09-5.95 11.027-13.29 11.027a16 16 0 0 1-2.347-.172 3.69 3.69 0 0 0-2.73.707 8 8 0 0 1-.96.628c-1.091.596-2.269.747-2.466.56s.397-.643.94-1.35q.134-.174.258-.371c.488-.767.09-1.733-.682-2.216C2.081 18.73 0 15.531 0 11.929 0 5.839 5.95.902 13.289.902c7.34 0 13.289 4.937 13.289 11.027"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sms_svg__a",
    x1: 13.289,
    x2: 13.289,
    y1: 0.902,
    y2: 24.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427CFF"
  })))));
};
export { SvgSms as ReactComponent };